<template>
  <div class="bgc-body">
    <v-tabs
      fixed-tabs
      color="orange"
      background-color="#252525"
      dark
      show-arrows
      center-active
    >
      <v-tab
        value="all"
        to="/blog/all"
        v-on:click="updateCategory('all')"
      >
        All
      </v-tab>
      <v-tab
        v-for="(value, i) in categories"
        :key="value.id + i"
        :value="value.slug"
        :to="value.href"
        v-on:click="updateCategory(value.id)"
      >
        {{value.name}}
      </v-tab>
    </v-tabs>

    <v-container class="maw940 mt10">
      <v-row>
        <v-col cols="12" xs="8" offset-xs="1">

          <bloglist
            :category="selectedCategory"
            :key="selectedCategory"
          />

        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<style scoped>
.bgc-body {
  background-color: #f4f4f4;
}
.tab {
  background-color: hsla(0,0%,100%,.6) !important;
}
.tab--text {
  color: #444 !important;
}
</style>

<script>
import bloglist from './partials/blog-list'

export default {
  components: {
    bloglist,
  },
  props: {
    category: {type: String},
  },

  created: function() {
    this.updateCategory(this.category);
    this.getAllCategories();
  },
  watch: {
    selectedCategory: function () {
      this.updateCategory(this.selectedCategory);
    },
  },
  methods: {
    getAllCategories () {
      // Get all categories for the tabs
      this.$prismic.client.query(
        this.$prismic.Predicates.at("document.type", "categories"),
          {orderings: '[my.categories.name]'}
          // TODO: only fetch what you need
      ).then((response) => {
        response.results.forEach(returnedData => {
            this.categories.push({id: returnedData.id, slug: returnedData.slugs[0], name: returnedData.data.name, href: "/blog/"+returnedData.slugs[0]});
            if(this.category == returnedData.slugs[0]) {this.selectedCategory = returnedData.id}
        });
      })
    },
    updateCategory (value) {
      this.selectedCategory = value;
    },
  },
  data() {
    return {
      categories: [],
      selectedCategory: 'all'
    }
  },
}
</script>